import React from 'react';

import { RowButton } from '@eika/button';

import { Format } from '@domain/app';
import { DebitAccount } from '@generated-types';

import './ReceiverListItem.scss';

interface Props {
    account: DebitAccount;
    onClick: () => void;
}

const ReceiverListItem: React.FC<Props> = ({ account, onClick }) => (
    <RowButton className="receiver-list-item__button" onClick={onClick}>
        <div className="receiver-list-item__list-item">
            <span className="receiver-list-item__list-item-name">{account.agreementName ?? account.productName}</span>
            <span className="receiver-list-item__list-item-number">{Format.accountNumber(account.number, '.')}</span>
        </div>
    </RowButton>
);

export default ReceiverListItem;
